import CustomizeUIStore from '../stores/CustomizeUI/CustomizeUIStore';
import makeInitStoresFn from '../stores/makeInitStoresFn';
import EnvStore from '../stores/EnvStore';
import ChangePasswordStore from '../stores/ChangePasswordStore';
import ConsoleCustomerSelectStore from '../stores/ConsoleCustomerSelectStore';
import ConsoleLoginStore from '../stores/ConsoleLoginStore';
import ConsoleStore from '../stores/ConsoleStore';
import BrowserPoliciesStore from '../stores/BrowserPolicies/BrowserPoliciesStore';
import { DashboardStore, UrlIsoDashboardStore } from '../stores/DashboardStore';
import EmailRegStore from '../stores/EmailRegStore';
import ForgotPasswordStore from '../stores/ForgotPasswordStore';
import IpRegStore from '../stores/IpRegStore';
import PolicyMigrationStore from '../stores/PolicyMigrationStore';
import RegOptionsStore from '../stores/RegOptionsStore';
import SetupPasswordStore from '../stores/SetupPasswordStore';
import SnackStore from '../stores/SnackStore';
import UDPolicyStore from '../stores/UDPolicies/UDPoliciesStore';
import ReportingApiStore from '../stores/ReportingApiStore';
import AdminTimeoutStore from '../stores/AdminTimeoutStore';
import CustomPagesStore from '../stores/CustomPagesStore';
import AuditStore from '../stores/AuditStore';
import ConsoleNavigationStore from '../stores/ConsoleNavigationStore';
import PolicyStore from '../stores/Policy/PolicyStore';
import ConsoleSamlAccessStore from '../stores/ConsoleSamlAccessStore/ConsoleSamlAccessStore';
import AuthenticationConfigurationStore
    from '../stores/AuthenticationConfigurationSSO/AuthenticationConfigurationStore';
import LocalAccountsStore from '../stores/LocalAccounts/LocalAccountsStore';
import BrowserBarOptionsStore from '../stores/BrowserBarOptionsStore';
import ExitMessageStore from '../stores/ExitMessageStore';

const initConsoleStores = makeInitStoresFn({
    env: EnvStore,
    console: ConsoleStore,
    snack: SnackStore,
    consoleLogin: ConsoleLoginStore,
    forgotPassword: ForgotPasswordStore,
    setupPassword: SetupPasswordStore,
    changePassword: ChangePasswordStore,
    dashboard: DashboardStore,
    urlIsoDashboard: UrlIsoDashboardStore,
    browserPolicies: BrowserPoliciesStore,
    regOptions: RegOptionsStore,
    emailReg: EmailRegStore,
    ipReg: IpRegStore,
    customerSelect: ConsoleCustomerSelectStore,
    udPolicies: UDPolicyStore,
    policy: PolicyStore,
    policyMigration: PolicyMigrationStore,
    localAccounts: LocalAccountsStore,
    consoleSamlAccess: ConsoleSamlAccessStore,
    reportingApi: ReportingApiStore,
    adminTimeout: AdminTimeoutStore,
    customPages: CustomPagesStore,
    audit: AuditStore,
    consoleNavigation: ConsoleNavigationStore,
    authenticationConfiguration: AuthenticationConfigurationStore,
    browserBarOptions: BrowserBarOptionsStore,
    exitMessage: ExitMessageStore,
    customizeUI: CustomizeUIStore,
});

export default initConsoleStores;
